<template>
  <v-layout wrap>
    <v-flex
      xs12
      sm12
      v-for="job in jobs"
      v-bind:key="job._id"
      class="list-section pa-2 mx-3 mb-0 mb-3"
    >
      <div>
        <v-btn class="right" icon @click="deleteModal(job._id)"><v-icon color="red">delete</v-icon></v-btn>
        <div class="right mt-2" v-if="job.jobId.is_vip_featured == true">
          <v-chip color="orange" dark small><v-icon color="white"></v-icon>Featured</v-chip>
        </div>
        <span class="bold"><b>Job Title:</b> {{job.jobId.title}}</span>
        <span class="right bold">{{job.jobId.locationName}}</span>
      </div>

      <div>          
          <p><div v-html="job.jobId.description"></div></p>
      </div>

      <div>
        <h4>Time Frame: <span class="font-weight-regular">{{job.jobId.timeFrame}}</span></h4>
        <h4><strong>Primary Job Location: </strong><span class="font-weight-regular">{{job.jobId.location.locationName}}</span></h4>
        <h4 v-if="job.jobId.is_vip_featured == true && (job.sonko.locationOne || job.sonko.locationTwo || job.sonko.locationThree || job.sonko.locationFour)"><strong>Additional Preferred Expert Locations: </strong>
          <span class="font-weight-regular" v-if="job.sonko.locationOne">{{job.sonko.locationOne.locationName}}</span>
          <span class="font-weight-regular" v-if="job.sonko.locationTwo">: {{job.sonko.locationTwo.locationName}}</span>
          <span class="font-weight-regular" v-if="job.sonko.locationThree">: {{job.sonko.locationThree.locationName}}</span>
          <span class="font-weight-regular" v-if="job.sonko.locationFour">: {{job.sonko.locationFour.locationName}}</span>
        </h4>
        <h4>Posted On: <span class="font-weight-regular">{{job.jobId.createdAt | moment("DD MMMM YYYY") }}</span></h4>
        <h4>Sonko Phone: 
          <a class="font-weight-regular" :href="`tel:${job.sonko.countryCode}${job.sonko.phone}`"><v-icon>phone</v-icon>{{job.sonko.countryCode}}{{job.sonko.phone}}</a>
          <a v-if="job.sonko.countryCode" :href="`https://wa.me/${job.sonko.countryCode.replace('+','')}${job.sonko.phone}`" target="_blank">
          <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;vertical-align: middle;" alt="">
          </a>
        </h4>
        <h4>Sonko Name: <span class="font-weight-regular">{{job.sonko.firstName}} {{job.sonko.lastName}}</span></h4>
        <h4>Email: <span class="font-weight-regular">{{job.sonko.email}}</span></h4>
      </div>

      <!-- <div>
        <p>Time Frame: {{job.jobId.timeFrame}}<br>
          Job Location: {{job.jobId.location.locationName}}<br>
          Posted On: {{job.jobId.createdAt | moment("DD MMMM YYYY") }}
        </p>
      </div> -->

      <!-- <div>
        Sonko Name: {{job.sonko.firstName}} {{job.sonko.lastName}}<br>
        Phone: {{job.sonko.phone}}<br>
        Email: {{job.sonko.email}}<br>
        Location: {{job.sonko.locationOne.locationName}}
      </div> -->
      <!-- <div>        
        Sonko Phone: <a :href="`tel:${job.sonko.countryCode}${job.sonko.phone}`"><v-icon>phone</v-icon>{{job.sonko.countryCode}}{{job.sonko.phone}}</a><br>
        Sonko Name: {{job.sonko.firstName}} {{job.sonko.lastName}}<br>
        Email: {{job.sonko.email}}
      </div> -->
      <div>
        <v-btn flat color="btnColor" :to="`/expert/job/details/${job.jobId._id}`">More Details</v-btn>
        
        <span v-if="job.jobId.expired == true || job.jobId.status == 'expired'" style="color: red" class="right">Expired</span>
        <span v-else-if="job.jobId.active == true && job.jobId.assigned == true" style="color: green" class="right">Job Assigned; Engage the Sonko</span>
        <span v-else-if="job.jobId.active == false" style="color: red" class="right">Job Unavailable</span>
        <span v-else style="color: green" class="right">
          Job Assigned; Engage the Sonko
        </span>
      </div>
    </v-flex>

  <!-- delete modal -->
        <v-dialog v-model="deleteDialog" max-width="750px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Delete Assignment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="deleteDialog = false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 class="experience"> Are you sure you want to delete this assignment? </v-flex>

                <v-flex xs6>
                  <v-btn color="red" dark :loading="loader" @click="deleteAssignment">
                    <v-icon left>delete</v-icon>Delete
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
  <!-- end of delete modal -->
  </v-layout>
</template>


<script>
export default {
  name: "AssignedJobsComponent",
  props: {
    jobs: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      deleteDialog: false,
      id: null,
      loader: false
    }
  },
  methods: {
    deleteModal(id) {
      this.id = id;
      this.deleteDialog = true;
    },
    deleteAssignment() {
      const id = this.id;
      const self = this;
      self.loader = true;
      this.$store
      .dispatch("remove", "/expert/assignment/delete/" + id)
      .then(res => {
        location.reload();
      });
    }
  }
};
</script>

<style scoped>
    .bold {
        font-weight: bold;
        color: orange;
    }
</style>

